import React from "react";
import { Box, Grid, Typography, Paper, Container ,Chip} from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

const threePillars = [
  
   
      <>
        <b style={{fontSize:"1.2rem"}}>Join</b> 
        <br></br> create you I Am <br></br> Peacekeeper profile.
      </>,
   
    
 
    
      <>
        <b style={{fontSize:"1.2rem"}}>Connect</b>  <br></br>
        view and connect with <br></br> members worldwide.
      </>,

      <>
       <b style={{fontSize:"1.2rem"}}>Collaborate</b>  <br></br> join Clubs.
      </>,

      <>
        <b style={{fontSize:"1.2rem"}}>Engage</b>   <br></br>
       live chat, forums <br></br> and events.
      </>

];

const values = [
  { label: "Location", color: "#9cd37b" },
  { label: "Interest", color: "#86cdbe" },
  { label: "Profession", color: "#9cd37b" },
  { label: "Business", color: "#86cdbe" },
  { label: "Age", color: "#9cd37b" },
  { label: "Gender", color: "#86cdbe" },
  { label: "Culture", color: "#9cd37b" },
   
];

const networkCircle = [
  {
    text: (
      <>
        Join the movement, 
        <br></br> connect with <br></br> fellow  I Am Peacekeeper.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Share your journey <br></br>
        and inspire others.
      </>
    ),
    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Build meaningful <br></br> connections worldwide.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Join your Club <br></br>
       and grow your Network today.
      </>
    ),
    colorClass: "gradient-yellow",
  },
];

const featuresData = [
  {
    text: (
      <>
        Profile sharing.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Live chat (direct and groups).
      </>
    ),
    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Clubs directory (see 7 categories below).
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Club invitations.
      </>
    ),
    colorClass: "gradient-yellow",
  },

   {
    text: (
      <>
        Event hosting (virtual and in‑person).
      </>
    ),
    colorClass: "gradient-blue",
  },
   {
    text: (
      <>
        Content sharing (updates, photos, resources).
      </>
    ),
    colorClass: "gradient-yellow",
  },
    {
    text: (
      <>
        Global search (people, clubs, interests).


      </>
    ),
    colorClass: "gradient-blue",
  },

  
];

// const theme = createTheme({
//   palette: {
//     mode: 'light',
//     primary: {
//       main: '#1976d2',
//     },
//   },
// });

const capabilities = [
  'Public Clubs.',
  'Club messaging boards.',
  'Member tagging and mentions.',
  <>
  Video meetings <i>(Zoom/Teams/Meet) </i>
  </>,
  'Club polls and surveys.',
  'File sharing in groups.',
  'Event RSVPs and reminders.',
  'Member status updates.',
  'Profile levels for engagement.',
  'Moderation tools for club admins.',
  'Push/email notifications.',
  'Multi‑language interface.',
];

// const forumData = [
//   {
//     title: <> <b>Forum</b> Categories</>,
//     items: ['Justice', '  •',  'Love', '  •',  'Peace'],
//     bgClass: 'lightGreenBg',
//   },
//   {
//     title: <> <b>Themes</b> </>,
//     items: ['Dignity, Equality, Solidarity', '  •',  'Non-Discrimination', '  •',  'Mutual Respect'],
//     bgClass: 'lightGrayBg',
//   },
//   {
//     title: <> <b>Features</b> </>,
//     items: [
//       'Threads, Profiles, Posts', '  •', 
//       'I Am Peacekeeper Events',
//       'I Am Peacekeeper Wall', '  •', 
//       'Moderated environment',
//     ],
//     bgClass: 'lightGreenBg',
//   },
// ];


const ThreePillarsCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards ${colorClass}`}
    sx={{
      width: 130,
      height: 130,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--default-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const FeaturesCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards ${colorClass}`}
    sx={{
      width: 130,
      height: 130,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard" style={{height:"80px"}}>
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const Networks = () => {
  return (
    <>
      {/* Book Hero Background Section */}
      <Box
        className="programBookSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Book section */}
      <Box className="bookPath">
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            item
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
            <Typography variant="h1"className="founder-title mainHeading green-title">
            I Am Peacekeeper Networks
            </Typography>
          </Grid>
        </Grid>
        <Typography variant="h2" sx={{fontFamily:'Trebuchet MS'}}>
          A purpose-driven Global hub where each I Am Peacekeeper can create a profile, join clubs, connect through chat and collaborate worldwide.          
        </Typography>
      </Box>

      {/* Three Pillars */}
      <Box mt={5} mb={5} className="mb-30px schoolProgramMainSection">
      

            <Container className="paddingContainer mt-20px">
            <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                {threePillars.map((text, index) => (
                             <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                               <InfoCard text={text} 
                                />
                             </Grid>
                           ))}
            </Grid>
            </Container>
      </Box>

     
     <Box mt={5} className="mt-50px coreFeaturesSection">
        <Grid container direction="column" alignItems="center" spacing={2} className="mt-50px">
          <Grid
            
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <Typography variant="h2"
                          align="center"
                          fontWeight={400}
                          gutterBottom
                          className="subHeading"
                          sx={{ fontFamily: 'var(--heading-font)' }}
                          >
             Core Features
            </Typography>
            
          </Grid>
        </Grid>

            <Container className="paddingContainer mt-20px max-width-800px">
            <Grid container spacing={2} justifyContent="center" mb={4}>
                {featuresData.map(({ text, colorClass }, index) => (
                <Grid size={{ xs: 12, md: 3 , sm:3 }}key={index}>
                    <FeaturesCard text={text} colorClass={colorClass} />
                </Grid>
                ))}
            </Grid>
            </Container>
      </Box>

       {/* 7 club categories section */}
        <Box className="founder-card" mb={5}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              className="d-flex-align-center-justify-center flex-direction-column w-100"
            >
            <Typography variant="h2" className="subHeading" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
                7 club categories
              </Typography>

              <Grid container spacing={1} justifyContent="center">
                {values.slice(0, 4).map((val) => (
                  <Grid item key={val.label}>
                    <Chip
                      label={val.label}
                      style={{ backgroundColor: val.color, fontFamily: 'var(--primary-font)', fontWeight: 400 }}
                      className="value-chip"
                    />
                  </Grid>
                ))}
              </Grid>
              <Grid
                container
                spacing={1}
                justifyContent="center"
                sx={{ mt: 1 }}
              >
                {values.slice(4).map((val) => (
                  <Grid item key={val.label}>
                    <Chip
                      label={val.label}
                      style={{ backgroundColor: val.color, fontFamily: 'var(--primary-font)', fontWeight: 400 }}
                      className="value-chip"
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

           
          </Grid>
        </Box>
        
        {/* networking hub */}

     
      <Box sx={{ p: 4 }} className="networkCapibilitiesSection">
        <Container>
             <Typography variant="h2" gutterBottom align="center" className="subHeading" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
          Networking Hub
        </Typography>
        <Grid container spacing={3}>
          {capabilities.map((capability, index) => (
            <Grid size={{ xs: 12, md: 3 , sm:4 }} key={index}>
              <Paper elevation={2} sx={{ p: 2 }}>
                <Typography variant="body1" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{capability}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        </Container>
       
      </Box>
    

        {/* circle Pillars */}
      <Box sx={{marginBottom:'70px'}}>
        {/* <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <Typography variant="h5" className="founder-title mainHeading green-title">
              Four Pillars
            </Typography>
          </Grid>
        </Grid> */}
         <Typography variant="h2" gutterBottom align="center" className="subHeading" mt={4} sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
         Way Forward
        </Typography>

            <Container className="paddingContainer mt-50px circlePillarsCard" mb={5}>
            <Grid container spacing={2} justifyContent="center" mb={5}>
                {networkCircle.map(({ text, colorClass }, index) => (
                <Grid size={{ xs: 12, md: 2 , sm:3 }}key={index}>
                    <ThreePillarsCard text={text} colorClass={colorClass} />
                </Grid>
                ))}
            </Grid>
            </Container>
      </Box>


      {/* quotes Section */}

      {/* <Box mt={3}>
        <Grid container alignItems="center" justifyContent="center">
            <Grid size={12}>
                      <div className="pledgeQuotes">
                        <Typography variant="body1" className="quote-text">
                           I Am Peacekeeper Book is a global  <br></br> house of thought, kindness,<br></br> courage, and commitment. 
                        </Typography>
                      </div>
                        
                      </Grid>
        </Grid>
      </Box> */}
    </>
  );
};

export default Networks;
